/**
 * BrewNectar — scroll to #offers / hash anchors flush below the fixed header.
 */
(function () {
  'use strict';

  var OFFERS_HASH = '#offers';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    var spacer = document.querySelector('.bn-header__spacer');
    if (spacer) {
      var spacerHeight = spacer.getBoundingClientRect().height;
      if (spacerHeight > 0) return spacerHeight;
    }

    var headerGroup = document.querySelector('.bn-header-group');
    if (headerGroup) {
      var ticker = headerGroup.querySelector('.bn-header__ticker');
      var nav = headerGroup.querySelector('.bn-header');
      var measured = 0;
      if (ticker && ticker.offsetParent !== null) measured += ticker.offsetHeight;
      if (nav) measured += nav.offsetHeight;
      if (measured > 0) return measured;

      var cssVar = getComputedStyle(headerGroup).getPropertyValue('--bn-header-total').trim();
      var parsed = parseFloat(cssVar);
      if (Number.isFinite(parsed) && parsed > 0) return parsed;
    }

    return 104;
  }

  function syncDocumentScrollPadding() {
    var offset = getHeaderOffset();
    document.documentElement.style.setProperty('--bn-header-total', offset + 'px');
    document.documentElement.style.scrollPaddingTop = offset + 'px';
  }

  function scrollToElement(target, options) {
    if (!target) return false;

    var behavior = 'smooth';
    if (options && options.behavior) {
      behavior = options.behavior;
    } else if (prefersReducedMotion()) {
      behavior = 'auto';
    }

    var offset =
      options && typeof options.offset === 'number' ? options.offset : getHeaderOffset();

    syncDocumentScrollPadding();

    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior
    });

    return true;
  }

  function scrollToHash(hash, options) {
    if (!hash || hash.charAt(0) !== '#') return false;
    var id = hash.slice(1);
    if (!id) return false;
    var target = document.getElementById(id);
    if (!target) return false;
    return scrollToElement(target, options);
  }

  function resolveOffersTarget() {
    return document.getElementById('offers');
  }

  function handleOffersLink(event, link) {
    var target = resolveOffersTarget();
    if (!target) return false;

    event.preventDefault();
    scrollToElement(target);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', OFFERS_HASH);
    }
    return true;
  }

  function isSamePageOffersLink(link) {
    var raw = (link.getAttribute('href') || '').trim();
    if (raw === OFFERS_HASH) return true;
    try {
      var url = new URL(raw, window.location.href);
      return url.pathname === window.location.pathname && url.hash === OFFERS_HASH;
    } catch (error) {
      return false;
    }
  }

  function bindGlobalOffersLinks() {
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a[href]');
        if (!link || link.target === '_blank' || link.dataset.bnScrollNative === 'true') return;
        if (!isSamePageOffersLink(link)) return;
        handleOffersLink(event, link);
      },
      true
    );
  }

  function scrollToHashOnLoad() {
    if (window.location.hash !== OFFERS_HASH) return;
    var target = resolveOffersTarget();
    if (!target) return;

    window.requestAnimationFrame(function () {
      scrollToElement(target, { behavior: 'auto' });
    });
  }

  window.BrewNectarScroll = {
    getHeaderOffset: getHeaderOffset,
    syncDocumentScrollPadding: syncDocumentScrollPadding,
    scrollToElement: scrollToElement,
    scrollToHash: scrollToHash
  };

  syncDocumentScrollPadding();
  bindGlobalOffersLinks();

  window.addEventListener('resize', syncDocumentScrollPadding);
  window.addEventListener('load', syncDocumentScrollPadding);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToHashOnLoad);
  } else {
    scrollToHashOnLoad();
  }
})();
